import { MessageSquareOff, Search, Copy, HelpCircle } from "lucide-react";
import { useScrollAnimation } from "@/hooks/useScrollAnimation";
import { cn } from "@/lib/utils";
import { Badge } from "@/components/ui/badge";

const WarumOmnichannelSection = () => {
  const { ref, isVisible } = useScrollAnimation();

  const problems = [
    { icon: MessageSquareOff, text: "Verteilte Gesprächsverläufe" },
    { icon: Search, text: "Fehlender Kontext" },
    { icon: Copy, text: "Doppelte Bearbeitung" },
    { icon: HelpCircle, text: "Unklare Zuständigkeiten" },
  ];

  return (
    <section
      ref={ref as React.RefObject<HTMLElement>}
      className={cn(
        "py-16 md:py-24 transition-all duration-700 ease-out",
        isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-8"
      )}
    >
      <div className="container mx-auto px-4">
        <div className="max-w-4xl mx-auto">
          <div className="text-center">
            <Badge variant="outline" className="mb-4 text-sm font-semibold text-primary uppercase tracking-wider">Das Problem</Badge>

            <h2 className="text-3xl md:text-4xl font-semibold text-foreground mb-6">
              Warum eine Unified Inbox?
            </h2>
          </div>

          <p className="text-xl text-muted-foreground text-center mb-4">
            Kunden kommunizieren heute parallel über unterschiedliche Kanäle.
            Ohne zentrale Steuerung entstehen schnell:
          </p>

          <div className="grid sm:grid-cols-2 lg:grid-cols-4 gap-4 mb-12">
            {problems.map((problem, index) => (
              <div
                key={index}
                className={cn(
                  "bg-secondary/50 rounded-xl p-5 text-center transition-all",
                  isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-4"
                )}
                style={{ transitionDelay: isVisible ? `${index * 150}ms` : "0ms", transitionDuration: "500ms" }}
              >
                <div className="w-10 h-10 rounded-xl bg-chathero-orange/20 flex items-center justify-center mx-auto mb-3">
                  <problem.icon className="w-5 h-5 text-chathero-orange" />
                </div>
                <p className="text-foreground text-sm">{problem.text}</p>
              </div>
            ))}
          </div>

          <div className="bg-chathero-mint/10 border border-chathero-mint/20 rounded-2xl p-8">
            <h3 className="text-xl font-semibold text-primary mb-3 text-center">
              Die Unified Inbox von Chathero schafft hier eine klare Struktur
            </h3>
            <p className="text-muted-foreground text-center">
              Sie macht Kundenkommunikation übersichtlich, teamfähig und KI-gestützt steuerbar – unabhängig vom Kanal oder der Komplexität der Anfrage.
            </p>
          </div>
        </div>
      </div>
    </section>
  );
};

export default WarumOmnichannelSection;
